module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Praise for Asprin ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“Plenty of odd characters … fun!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Locus")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“A winning story … part science fiction, part spoof, part heart-warmer.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Publisher’s Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“Light without being frivolous, and displays Asprin’s considerable expertise about fencing and things military, especially leadership.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Chicago Sun-Times")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“Reminiscent of "), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__No_Italic"
  }, [_vm._v("M*A*S*H.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Analog")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“A grand mix of common sense, outrageous and hilarious foolishness stirred with a dash of wisdom into a delectable mess to be served with tongue in cheek.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Kliatt")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“Reliably entertaining … a fun read, light without being vapid and clever without being heavy-handed. This series is Asprin’s strongest to date, and it’s off to a good start.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Amazing")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("“Asprin knows how to make me laugh … I suggest you sign up for this particular grand tour of duty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("–"), _c('i', [_vm._v("Fear")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0